module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _domready = __webpack_require__(1);

	var _domready2 = _interopRequireDefault(_domready);

	var _tocss = __webpack_require__(2);

	var _tocss2 = _interopRequireDefault(_tocss);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global window:true document:true */


	function memoize(fn) {
	  var memo = void 0;
	  return function memofiy() {
	    if (memo == null) memo = fn();
	    return memo;
	  };
	}

	var getHeadElement = memoize(function () {
	  return document.head || document.getElementsByTagName('head')[0];
	});
	var previousGlobalStyleElement = null;

	function beautifulClassName(componentName, id) {
	  return componentName.toLowerCase() + id.replace('node_', '-');
	}

	function insertStyleElement(styleElement) {
	  getHeadElement().appendChild(styleElement);
	}

	function _createStyleElement() {
	  var styleElement = document.createElement('style');
	  styleElement.type = 'text/css';
	  insertStyleElement(styleElement);
	  return styleElement;
	}

	function writeGlobalCss(css) {
	  if (previousGlobalStyleElement) {
	    previousGlobalStyleElement.parentNode.removeChild(previousGlobalStyleElement);
	  }
	  previousGlobalStyleElement = _createStyleElement();
	  if (previousGlobalStyleElement.styleSheet) {
	    previousGlobalStyleElement.styleSheet.cssText = css;
	  } else {
	    previousGlobalStyleElement.appendChild(document.createTextNode(css));
	  }
	}

	var StyleProcessor = function () {
	  function StyleProcessor() {
	    var _this = this;

	    _classCallCheck(this, StyleProcessor);

	    this.cssCollection = [];
	    this.readyTask = [];
	    this.isReady = false;
	    if (getHeadElement()) {
	      this.prepare();
	    } else {
	      (0, _domready2.default)(function () {
	        return _this.prepare();
	      });
	    }
	  }

	  StyleProcessor.prototype.setNamespace = function setNamespace(namespace) {
	    // this.namespace = namespace;
	  };

	  StyleProcessor.prototype.setDesignMode = function setDesignMode(flag) {
	    this.designMode = flag;
	  };

	  StyleProcessor.prototype.isDesignMode = function isDesignMode() {
	    return this.designMode;
	  };

	  StyleProcessor.prototype.prepare = function prepare() {
	    this.isReady = true;
	    var doe = document.documentElement;
	    if (!doe.id) {
	      doe.id = 'rehtml-' + (+new Date()).toString(36);
	    }
	    this.namespace = '#' + doe.id;
	    var fn = void 0;
	    while ((fn = this.readyTask.shift()) != null) {
	      // eslint-disable-line
	      fn();
	    }
	  };

	  StyleProcessor.prototype.createCss = function createCss(selector, styles) {
	    var _this2 = this;

	    if (!styles) {
	      return '';
	    }
	    if (this.namespace && selector[0] === '.') {
	      selector = this.namespace + ' ' + selector;
	    }
	    if ({}.toString.call(styles) === '[object String]') {
	      if (/:root/ig.test(styles)) {
	        return styles.replace(/:root/ig, selector);
	      }
	      return selector + '{' + styles + '}';
	    }
	    if (styles.default) {
	      var css = [];
	      css.push(selector + '{' + (0, _tocss2.default)(styles.default) + '}');
	      ['hover', 'focus', 'active'].forEach(function (state) {
	        if (styles.hasOwnProperty(state)) {
	          var selectorStr = _this2.designMode ? selector + ':' + state + ',' + selector + '.-pseudo-' + state : selector + ':' + state;
	          css.push(selectorStr + '{' + (0, _tocss2.default)(styles[state]) + '}');
	        }
	      });
	      return css.join('\n');
	    }

	    return selector + '{' + (0, _tocss2.default)(styles) + '}';
	  };

	  StyleProcessor.prototype.addCssText = function addCssText(text) {
	    var i = this.cssCollection.indexOf(text);
	    if (i < 0) {
	      this.cssCollection.push(text);
	    }
	  };

	  StyleProcessor.prototype.clearCollection = function clearCollection() {
	    this.cssCollection = [];
	  };

	  StyleProcessor.prototype.collectStyle = function collectStyle(id, componentName, props) {
	    var className = beautifulClassName(componentName, id);
	    props.className = className;
	    if (props.style) {
	      this.addCssText(this.createCss('.' + className, props.style));
	    } else if (props.containerStyle) {
	      this.addCssText(this.createCss('.' + className, props.containerStyle));
	    }
	    if (props.itemStyle) {
	      this.addCssText(this.createCss('.' + className + '-item', props.itemStyle));
	    }
	    if (props.pageStyle) {
	      this.addCssText(this.createCss('body', props.pageStyle));
	    }
	  };

	  StyleProcessor.prototype.applyStyle = function applyStyle() {
	    var css = this.cssCollection.join('\n');
	    this.ready(function () {
	      return writeGlobalCss(css);
	    });
	  };

	  StyleProcessor.prototype.ready = function ready(func) {
	    if (this.isReady) {
	      func();
	      return;
	    }
	    this.readyTask.push(func);
	  };

	  StyleProcessor.prototype.createStyleElement = function createStyleElement() {
	    return _createStyleElement();
	  };

	  return StyleProcessor;
	}();

	if (!window.__visionStyleProcessor) {
	  window.__visionStyleProcessor = new StyleProcessor();
	}

	exports.default = window.__visionStyleProcessor;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = require("domready");

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.default = toCss;

	var _inlineStylePrefixer = __webpack_require__(3);

	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var prefixer = new _inlineStylePrefixer2.default(typeof navigator !== 'undefined' && navigator || { userAgent: 'Chrome/20.0.1216.0' });

	var AutoUnitless = ['animation', 'columnCount', 'columns', 'fontWeight', 'opacity', 'order', 'zIndex', 'zoom', 'flex', 'boxFlex', 'transform', 'perspective', 'boxPack', 'boxAlign', 'colspan', 'rowspan', 'lineHeight', 'WebkitLineClamp'];

	var RE_CAMEL = /[A-Z]/g;
	var RE_HYPHEN = /[-\s]+(.)?/g;

	function hyphenate(str) {
	  return str.replace(RE_CAMEL, function (w) {
	    return '-' + w;
	  }).toLowerCase();
	}

	function camelize(str) {
	  return str.replace(RE_HYPHEN, function (m, w) {
	    return w ? w.toUpperCase() : '';
	  });
	}

	var objectHasOwn = Object.prototype.hasOwnProperty;

	function hasOwn(object, propertyName) {
	  return objectHasOwn.call(object, propertyName);
	}

	function isNumeric(val) {
	  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	  return type === 'number' || type === 'string' && val !== '' && val * 1 == val;
	}

	function toObject(styles) {
	  var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	  var key = void 0;
	  var value = void 0;
	  var property = void 0;
	  for (key in styles) {
	    if (!hasOwn(styles, key)) {
	      continue;
	    }

	    value = styles[key];
	    property = camelize(prepend ? prepend + key : key);

	    if (value == null || property == null || property === '') {
	      continue;
	    }

	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      toObject(value, property + '-', result);
	      continue;
	    }

	    if (isNumeric(value) && AutoUnitless.indexOf(property) < 0) {
	      value = value + 'px';
	    }

	    result[property] = value;
	  }

	  return result;
	}

	function toCss(styles) {
	  var prefixed = prefixer.prefix(toObject(styles));
	  var collection = [];

	  var key = void 0;
	  for (key in prefixed) {
	    if (hasOwn(prefixed, key)) {
	      collection.push(hyphenate(key) + ':' + prefixed[key]);
	    }
	  }

	  return collection.join(';');
	}
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("inline-style-prefixer");

/***/ }
/******/ ]);